import axios from 'axios'
import store from '@/store'

axios.interceptors.request.use(config => {
    const token = store.state.auth.token
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
})

export default axios
